import React, { useCallback, useRef, useState } from "react";
import { appSupportedLanguages as languages } from "config/i18n/supported_language";
import { useTranslation } from "react-i18next";
import { FiCheck, FiChevronDown, FiGlobe } from "react-icons/fi";
import { useOutsideClick } from "hooks/useOutsideClick";

export const ChangeLanguage = () => {
  const { i18n } = useTranslation();

  const menuRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<boolean>(false);
  const langChangeHandler = useCallback((code: string) => {
    i18n.changeLanguage(code);
    setVisible(false);
  }, []);

  const toggleDropDown = useCallback(() => {
    setVisible(function (prevState) {
      return !prevState;
    });
  }, []);

  useOutsideClick(menuRef.current!, () => {
    setVisible(false);
  });

  const activeCode = (i18n.language || "").split("-")[0].toUpperCase();

  return (
    <div className="relative z-50 flex" ref={menuRef} onClick={toggleDropDown}>
      <button
        type="button"
        data-testid="globe-btn"
        className={`zs-icon-btn !w-auto gap-1 px-2 ${visible ? "is-active" : ""}`}
        aria-haspopup="listbox"
        aria-expanded={visible}
        aria-label="Change language"
      >
        <FiGlobe className="w-[18px] h-[18px]" />
        <span className="hidden text-xs font-semibold sm:inline">{activeCode}</span>
        <FiChevronDown className={`w-3.5 h-3.5 transition-transform ${visible ? "rotate-180" : ""}`} />
      </button>
      {visible ? (
        <ul
          style={{ maxHeight: "400px", overflowY: "auto" }}
          data-testid="dropDown_body"
          role="listbox"
          onClick={(e) => e.stopPropagation()}
          className="absolute right-0 p-1.5 w-56 text-left zs-popover zs-scroll top-11"
        >
          {languages.map(({ code, title }) => {
            const isCurrent = code === i18n.language;
            return (
              <li
                data-testid="listItem"
                role="option"
                aria-selected={isCurrent}
                className={`zs-menu-item language-list-item ${isCurrent ? "disabled is-active" : ""}`}
                key={code}
                onClick={(e) => {
                  e.stopPropagation();
                  langChangeHandler(code);
                }}
              >
                <span className="flex-1">{title}</span>
                {isCurrent && <FiCheck className="w-4 h-4" />}
              </li>
            );
          })}
        </ul>
      ) : (
        ""
      )}
    </div>
  );
};
